var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-rect": "stroke",
    x: 8,
    y: 10,
    width: 16,
    height: 12,
    rx: 2,
    stroke: "#1D1D46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M8 13L15.1056 16.5528C15.6686 16.8343 16.3314 16.8343 16.8944 16.5528L24 13",
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f6e41522c7e362914fe07bcbcc34b582.svg";
export { ForwardRef as ReactComponent };